import { USER_FETCH, USER_SUCCESS, USER_FAILURE, LOGOUT_REQUEST, USER_UPDATE, PREFIX_FETCH_START, PREFIX_FETCH_END } from "./../types"

const initialState = { isLoading: true, isLogin: false, userData: null, errorMessage: null, loadingGetPrefix: false, force: 0 }

export default function usersReducer(state = initialState, action) {
    switch (action.type) {
        case USER_FETCH: {
            return { ...state, isLoading: true, isLogin: false, userData: null, errorMessage: null }
        }
        case USER_SUCCESS: {
            return { ...state, isLoading: false, isLogin: true, userData: action.payload, errorMessage: null }
        }
        case USER_FAILURE: {
            return { ...state, isLoading: false, isLogin: false, userData: null, errorMessage: action.error }
        }
        case USER_UPDATE: {
            return { ...state, userData: { ...state.userData, ...action.payload } }
        }
        case LOGOUT_REQUEST: {
            localStorage.removeItem("Token")
            return { ...state, isLoading: false, isLogin: false, userData: null, errorMessage: null }
        }
        case PREFIX_FETCH_START: {
            return { ...state, loadingGetPrefix: true }
        }
        case PREFIX_FETCH_END: {
            return { ...state, loadingGetPrefix: false }
        }
        case "FORCE_UPDATE": {
            return { ...state, force: state.force + action.payload }
        }
        case "CancelLoading": {
            return { ...state, isLoading: false }
        }
        default:
            return state
    }
}